import React from "react";

interface LayoutContextInterface {
    fontSize?: { get:number, set:(size: number) => void },
    slideServices?: { get: number; set: (index: number) => void };
}

const context: LayoutContextInterface = {
};

const LayoutContext = React.createContext(context);

export default LayoutContext;